module.exports = require('./dist/yup');